module.exports = __webpack_public_path__ + "static/media/futureskill.2eeca9bd.png";